import UserData from './userData.js';

var GigyaUtil = function() {

    var config = null;
    var EID_DEFAULT_PERIOD = 60 * 1000; // 1 minute (in ms)
    var globalAuthEidUrl = null;


    var init = function(_config) {
        var eidParam = getEidOnUrl(),
            eidInfo = getEidInfo();

        config = _config;
        if (!config.loginExpireTime) {
            config.loginExpireTime = EID_DEFAULT_PERIOD;
        }

        if (eidParam) {
            writeEidCookie(eidParam, true);
            window.location = getModifiedUrl();
            return;
        }

        if (!(eidInfo.eid && eidInfo.adminMode && doEidLogin(eidInfo.eid))) {
            scriptLoader(config.scriptUrl, function() {
                if (config.isLoginPage) {
                    gigya.accounts.logout({callback:addEventListeners});
                    config.showScreenSetCallback();
                } else {
                    addEventListeners();
                }
            })
        }
    };

    var scriptLoader = function(script, callback) {

        function urlCallback(url) {
            return function () {
                callback();
            };
        }

        function loadScript(url) {
            var s = document.createElement('script');
            s.setAttribute('src', url);
            s.onload = urlCallback(url);
            document.head.appendChild(s);
        }

        loadScript(script);
    };

    var scriptInclude = function() {
        $.getScript(config.scriptUrl)
            .done(function (script, textStatus) {
                if (config.isLoginPage) {
                    gigya.accounts.logout({callback:addEventListeners});
                    config.showScreenSetCallback();
                } else {
                    addEventListeners();
                }
            })
            .fail(function (jqxhr, settings, exception) {
                console.log("No file found");
            });
    };

    function addEventListeners() {
        gigya.accounts.addEventHandlers({
            onLogin: onGigyaLogin,
            onLogout: onGigyaLogout,
            callback: eventListenerCallback,
            context: {eidExpired: config.eidExpired}
        });
    }

    function eventListenerCallback(response) {
        console.log(response);
        if (response.context.eidExpired) {
            logout();
        }
    }

    function onGigyaLogin(response) {
        console.log('onGigyaLogin');
        userInfoCall(response);
    }

    function onGigyaLogout(response) {
        console.log('onGigyaLogout');
        if (typeof config.logoutCallback === 'function') {
            config.logoutCallback(response.context ? response.context.adminLogout : false);
        }
    }

    function userInfoCall(response) {
        var data = {
            "UID": response.UID,
            "UIDSignature": response.UIDSignature,
            "signatureTimestamp": response.signatureTimestamp,
            "loginProvider": "site",
            "isRegistered": false,
            "isActive": true,
            "isLockedOut": false,
            "isVerified": false
        };

        if(config.isLoginPage) {
            config.hideScreenSetCallback();
            $('#wait-message').show();
        }
        $.ajax({
            type: "POST",
            url: config.authorizeUrl,
            contentType: "application/json",
            data: JSON.stringify(data),
            dataType: 'json',
            headers: {
                client_id: config.clientId,
                client_secret: config.clientSecret,
                Accept: 'application/json'
            }}).done( function (response) {
                personCallbackSuccess(response);
            }).fail( function(response) {
                personCallbackError(response);
        });
    }

    function logout() {
        try {
            var eidInfo = getEidInfo();

            removeEid();
            if (eidInfo.adminMode) {
                removeGigyaCookie();
                onGigyaLogout({context: {adminLogout: eidInfo.adminMode}});
            } else {
                gigya.accounts.logout({callback: onGigyaLogout, context: {adminLogout: eidInfo.adminMode}});
            }
        } catch(e) {}
    }

    function personCallbackSuccess(response) {
        if (response.status == 200) {
            storeUserInfo(new UserData(response, 'gigya'));
        }
    }

    function storeUserInfo(userInfo) {
        config.storeUserInfoCallback(userInfo, true);
        if (typeof config.scriptLoadedCallback === 'function') {
            config.scriptLoadedCallback();
        }
    }

    function personCallbackError(response) {
        if (config.isLoginPage) {
            $('#wait-message').hide();
            config.showScreenSetCallback();
            $('#loginFormAccountDisabled').show();
        }
    }

    function timeout(response) {
        if (config.isLoginPage) {
            $('#wait-message').hide();
            config.showScreenSetCallback();
        }
    }

    function doEidLogin(eid) {
        var userData = getUserInfo(eid);

        if (userData) {
            userData.adminMode = true;
            storeUserInfo(userData);
        }

        return userData != null;
    }

    function writeEidCookie(eid, adminMode) {
        var expires = new Date(),
            eidInfo = {
                adminMode: adminMode === true,
                eid: eid
            };
        expires.setTime(expires.getTime() + config.loginExpireTime);
        $.cookie("eid", JSON.stringify(eidInfo), {path: "/", expires: expires});
        $.cookie('USER_PROFILE_JWT', JSON.stringify(eid), {path: "/"});
    }

    function removeEid() {
        $.cookie('eid', null, {path:'/'})
    }

    function getUserInfo(eid) {
        var userInfo = null;

        $.ajax({
            url: getEidUrl() + '?eid=' + eid,
            type: "GET",
            async: false,
            beforeSend: function(xhr) {
                xhr.setRequestHeader("client_id", config.clientId);
                xhr.setRequestHeader("client_secret", config.clientSecret);
            }}).done(function(data) {
                console.log(data);
                userInfo = new UserData(data, 'simple.be');
            }).fail(function(data) {
                console.error('Error getting user data.');
        });

        return userInfo;
    }

    function getEidInfo() {
        var eidCookie = $.cookie('eid'),
            eidInfo = {
                adminMode: false,
                eid: null
            };

        if (eidCookie && eidCookie != 'null') {
            eidInfo = JSON.parse(eidCookie);
        }
        return eidInfo;
    }

    function getEid() {
        return getEidInfo().eid;
    }

    function isAdminMode() {
        return getEidInfo().adminMode;
    }

    function getEidUrl() {
        // Need the globalAuthEidUrl.  This is a global config setting.
        if (!globalAuthEidUrl) {
            $.ajax({
                url: config.environment + '/content/configuration/global/markets/americas.service.US.json',
                type: 'GET',
                dataType: "json",
                async: false
            }).done(function(data) {
                    globalAuthEidUrl = data.globalAuthEIDUrl;
            }).fail(function(xhr) {
                    console.log("Could not load market configuration! error:" + xhr);
                    console.log("Configuration URL: " + url);
            });
        }
        return globalAuthEidUrl;
    }

    function getEidOnUrl() {
        var paramMap = $.getQueryParameters(window.location.search);

        return paramMap.eid ? paramMap.eid : null;
    }
    function getModifiedUrl() {
        var paramMap = $.getQueryParameters(window.location.search),
            retVal = window.location.origin + window.location.pathname + window.location.hash,
            paramSeparator = '?';

        for (var key in paramMap) {
            if (paramMap.hasOwnProperty(key)) {
                if (key != 'eid') {
                    retVal += paramSeparator + key + "=" + paramMap[key];
                    if (paramSeparator === '?') {
                        paramSeparator = '&';
                    }
                }
            }
        }
        return retVal;
    }

    function removeGigyaCookie() {
        var cookieName = document.cookie.match(/^glt.*;/);

        if (!cookieName || cookieName === 'null') {
            cookieName = document.cookie.match(/^glt.*/);
        }

        if (cookieName && cookieName != 'null') {
            var expires = new Date();

            cookieName = cookieName[0].split('=')[0];
            expires.setTime(expires.getTime() - (1000 * 60 * 60 * 24));
            $.cookie(cookieName, null, {path:'/', expires: expires});
        }
    }


    return {
        init: init,
        userInfoCall: userInfoCall,
        getUserInfo: getUserInfo,
        logout: logout,
        getEid: getEid,
        adminMode: isAdminMode,
        writeEid: writeEidCookie
    }
};
export default GigyaUtil;

